(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/members.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/members.js');
"use strict";


const getMembersForTeam = (state, _ref) => {
  let {
    groupId
  } = _ref;
  return state.Members[groupId];
};
const selectMe = (state, _ref2) => {
  let {
    groupId
  } = _ref2;
  return (getMembersForTeam(state, {
    groupId
  }) || []).find(m => m.isMe) || null;
};
const seletMembersInTeam = (state, _ref3) => {
  let {
    groupId
  } = _ref3;
  return (getMembersForTeam(state, {
    groupId
  }) || []).length;
};
setGlobal('svs.components.marketplaceData.selectors.members', {
  selectMe,
  getMembersForTeam,
  seletMembersInTeam
});

 })(window);